"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationAmenities = void 0;
const infrastructure_1 = require("../../../infrastructure");
const utils_1 = require("@leavy/utils");
class AccommodationAmenities extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.selected));
    }
    toPlain() {
        return { ...this };
    }
}
exports.AccommodationAmenities = AccommodationAmenities;
//# sourceMappingURL=AccommodationAmenities.js.map